<template>
  <div class="finance-container">
    <!-- 2. 搜索筛选区 -->
    <el-card shadow="never" class="search-card">
      <el-form
        ref="searchFormRef" :model="searchForm" size="small"
        label-position="top"
      >
        <el-row :gutter="20">
          <!--时间-->
          <el-col :span="6">
            <el-form-item
              :label="$t('trajectory.Time')"
              prop="dateRange"
              :rules="{ required: true, message: $t('collectionCenter.notNull'), trigger: 'change'}"
            >
              <el-date-picker
                v-model="searchForm.dateRange"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <!--客户-->
          <el-col :span="6">
            <el-form-item
              :label="$t('GlobalSetObj.client')"
              prop="customerId"
              :rules="{ required: true, message: $t('collectionCenter.notNull'), trigger: 'change'}"
            >
              <el-select
                v-model="searchForm.customerId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @visible-change="getCustomerOption"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--资金大类-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.FundsCategory')">
              <el-select
                v-model="searchForm.fundCategory"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('basicData.recharge')" :value="1" />
                <el-option key="2" :label="$t('basicData.Refund')" :value="2" />
                <el-option key="3" :label="$t('basicData.Expense')" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <!--资金小类-->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.FundsSubcategory')">
              <el-select
                v-model="searchForm.expenseCategory"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('basicData.PlaceQuoteBilling')" :value="1" />
                <el-option key="2" :label="$t('basicData.OrderFeeRecalculation')" :value="2" />
                <el-option key="3" :label="$t('basicData.OrderCancel')" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <!--运单状态-->
          <el-col :span="6">
            <el-form-item :label="$t('newOrder.waybillStatus')">
              <el-select
                v-model="searchForm.wayBillStatus"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in waybillStatusList"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--运单号-->
          <el-col :span="6">
            <el-form-item :label="$t('newOrder.waybillNumber')">
              <template slot="label">
                <el-select v-model="searchForm.numberField" style="width: 100%">
                  <el-option
                    :label="$t('orderCenterCont.TheOrderNumber')"
                    value="order_number"
                  /><!--订单号-->
                  <el-option :label="$t('collectionCenter.customerNum')" value="waybill_number" /><!--客户单号-->
                </el-select>
              </template>
              <div>
                <el-input
                  v-model="searchNumber"
                  :placeholder="$t('basicData.search2000Rows')"
                  :rows="2"
                  type="textarea"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item style="margin-top: 30px;">
              <el-button
                size="small"
                type="primary"
                @click="clickSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!-- 1. 顶部统计卡片区 -->
    <div class="stats-row">
      <!-- 初期余额 -->
      <div class="stat-card">
        <div class="stat-label">{{ $t('basicData.InitialBalance') }}</div>
        <div class="stat-value">
          <svg-icon icon-class="money_bag" />
          <span>{{ formatMoney(balanceStatistics.beginBalance) }}</span>
        </div>
      </div>
      <!-- 充值/退款合计 -->
      <div class="stat-card">
        <div class="stat-label">{{ $t('basicData.RechargeRefundTotal') }}</div>
        <div class="stat-value">
          <svg-icon icon-class="money_bag" />
          <span>{{ formatMoney(balanceStatistics.rechargeAmount) }}</span>
        </div>
      </div>
      <!-- 支出合计 -->
      <div class="stat-card">
        <div class="stat-label">{{ $t('basicData.ExpenditureTotal') }}</div>
        <div class="stat-value">
          <svg-icon icon-class="money_bag" />
          <span>{{ formatMoney(balanceStatistics.expenseAmount) }}</span>
        </div>
      </div>
      <!-- 期末余额 -->
      <div class="stat-card">
        <div class="stat-label">{{ $t('basicData.EndingBalance') }}</div>
        <div class="stat-value">
          <svg-icon icon-class="money_bag" />
          <span>{{ formatMoney(balanceStatistics.endBalance) }}</span>
        </div>
      </div>
      <!-- 订单笔数 -->
      <div class="stat-card">
        <div class="stat-label">
          {{ $t('basicData.OrderQuantity') }}
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('basicData.OrderQuantity') + '：' + $t('basicData.ItWillCountDeduplicationBasedOnSearchResults')"
            placement="top"
          >
            <i class="el-icon-warning-outline" style="font-size: 18px;margin-left: 10px;" />
          </el-tooltip>
        </div>
        <div class="stat-value">
          <svg-icon icon-class="tongjibaobiao" />
          <span>{{ balanceStatistics.orderCount || 0 }}</span>
        </div>
      </div>
    </div>
    <!-- 3. 表格操作与展示区 -->
    <el-card class="table-card" shadow="never">
      <!-- 工具栏 -->
      <div class="table-toolbar">
        <el-button size="small" @click="handleExport">{{ $t('newOrder.export') }}</el-button>
        <el-button
          size="small"
          @click="openCustomColumn"
        >{{ $t('orderCenterCont.CustomizeListColumn') }}
        </el-button>
      </div>
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        border
        style="width: 100%"
      >
        <!--业务信息-->
        <el-table-column
          v-for="(item, index) in viewColumn"
          :key="index"
          :label="item.label"
          :align="item.align"
          :prop="item.prop"
        >
          <el-table-column
            v-for="(list, index1) in item.children"
            :key="index1"
            :label="list.label"
            :align="list.align"
            :prop="list.prop"
            :width="list.width"
          >
            <template slot-scope="scope">
              <div v-if="list.prop === 'index'">
                {{ scope.$index + 1 }}
              </div>
              <div v-else-if="list.prop === 'fundCategoryName'">
                <div v-if="scope.row.fundCategory === 1" class="fund-category" style="background: #409eff;">
                  {{ scope.row[list.prop] }}
                </div>
                <div v-else-if="scope.row.fundCategory === 2" class="fund-category" style="background: #f56c6c;">
                  {{ scope.row[list.prop] }}
                </div>
                <div v-else-if="scope.row.fundCategory === 3" class="fund-category" style="background: #e6a23c;">
                  {{ scope.row[list.prop] }}
                </div>
              </div>
              <div v-else-if="list.prop === 'expenseCategoryName'">
                <div v-if="scope.row[list.prop]" class="fund-category" style="border: 1px solid #409eff;color:#409eff;">
                  {{ scope.row[list.prop] }}
                </div>
              </div>
              <div v-else>
                {{ scope.row[list.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <el-dialog
        :title="$t('orderCenterCont.CustomizeListColumn')"
        :visible.sync="showCustomColumnDrawer"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        direction="ltr"
        width="600px"
        custom-class="demo-drawer"
      >
        <customColumn
          ref="customColumnRef"
          :key="customColumnKey"
          :new-column="newColumn"
          :selected-prop="selectedProp"
          @saveColumn="saveColumn"
        />
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="showCustomColumnDrawer = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="handleCustomColumn">{{ $t('GlobalSetObj.determine') }}</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import customColumn from './component/customColumn.vue';
import dayjs from 'dayjs';
import {
  getFundsTimeSeries, getFundsTimeSeriesTotal, walletLogExport
} from '@/api/finance/basicData';
import { apiCustomerPage } from '@/api/customer';
import { goFinanceExportPage } from '@/utils/goExportList.js';

export default {
  name: 'FundConsumptionSchedule',
  components: {
    customColumn
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      // 2. 搜索表单
      searchForm: {
        dateRange: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        fundCategory: null,
        expenseCategory: null,
        wayBillStatus: null,
        numberField: 'order_number',
        customerId: null
      },
      // 3. 表格假数据
      tableData: [],
      balanceStatistics: {},
      waybillStatusList: [
        { label: this.$t('basicData.OrderPlaced'), code: 30 }, // 已下单
        { label: this.$t('newOrder.ToBeCollected'), code: 2 }, // 待揽收
        { label: this.$t('newOrder.Collected'), code: 3 }, // 已揽收
        { label: this.$t('newOrder.TransshipmentIntoStorage'), code: 6 }, // 转运入库
        { label: this.$t('newOrder.TransferOutWarehouse'), code: 7 }, // 转运出库
        { label: this.$t('newOrder.DeliveryOutletsIntoStorage'), code: 8 }, // 派送网点入库
        { label: this.$t('newOrder.Delivering'), code: 9 }, // 派送中
        { label: this.$t('newOrder.Signed'), code: 10 }, // 已签收
        { label: this.$t('newOrder.ProblemPiece'), code: 11 }, // 问题件
        { label: this.$t('GlobalSetObj.Canceled'), code: 13 }, // 已取消
        // { label: this.$t('GlobalSetObj.DotBack'), code: 17 }, // 网点退回
        // { label: this.$t('GlobalSetObj.ReturnToStorage'), code: 18 }, // 退仓入库
        { label: this.$t('GlobalSetObj.Withdrawn'), code: 15 }, // 退件中
        { label: this.$t('GlobalSetObj.TheReturnComplete'), code: 16 } // 退件签收
        // { label: this.$t('GlobalSetObj.mutilSign'), code: 20 }
      ],
      searchNumber: '',
      tableColumn: [
        {
          label: this.$t('basicData.BusinessInformation'), // '业务信息',
          prop: 'business',
          align: 'center',
          children: [
            {
              label: this.$t('newOrder.SerialNumber'),
              prop: 'index',
              align: 'center',
              width: 80
            },
            {
              label: this.$t('trajectory.Time'), // '时间',
              prop: 'createTime',
              align: 'center'
            },
            {
              label: this.$t('collectionCenter.orderNumber'), // '订单号',
              prop: 'orderNumber',
              align: 'center'
            },
            {
              label: this.$t('collectionCenter.customerNum'), // '客户单号',
              prop: 'customerNumber',
              align: 'center'
            },
            {
              label: this.$t('newOrder.waybillStatus'), // '运单状态',
              prop: 'waybillStatusName',
              align: 'center'
            }
          ]
        },
        {
          label: this.$t('customerManagements.financialInformation'), // '财务信息',
          prop: 'funds',
          align: 'center',
          children: [
            {
              label: this.$t('basicData.FundsCategory'), // '资金大类',
              prop: 'fundCategoryName',
              align: 'center'
            },
            {
              label: this.$t('basicData.FundsSubcategory'), // '资金小类',
              prop: 'expenseCategoryName',
              align: 'center'
            },
            {
              label: this.$t('basicData.FeeAmount'), // '费用金额',
              prop: 'amountDisplay',
              align: 'center'
            },
            {
              label: this.$t('basicData.EndingBalance'), // '期末余额',
              prop: 'afterBalance',
              align: 'center'
            }
          ]
        }
      ],
      newColumn: [],
      showCustomColumnDrawer: false,
      customColumnKey: new Date().getTime(),
      selectedProp: [],
      viewColumn: [],
      customerList: []
    };
  },
  mounted() {
    const columnList = JSON.parse(localStorage.getItem('fundConsumptionColumnList'));
    const selectedProp = JSON.parse(localStorage.getItem('fundConsumptionSelectedProp'));
    if (columnList) {
      this.newColumn = columnList;
    } else {
      this.newColumn = this.tableColumn;
    }
    if (selectedProp) {
      this.selectedProp = selectedProp;
    } else {
      this.selectedProp = this.getAllProps(this.tableColumn);
    }
    this.viewColumn = this.filterColumnsByProps(this.newColumn, this.selectedProp);
    this.handleSearch();
  },
  methods: {
    // 打开客户选项弹窗
    getCustomerOption(val) {
      if (val) {
        this.getCustomerPage();
      }
    },
    // 获取客户
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 保存自定义栏目
    saveColumn(column, props) {
      this.viewColumn = this.filterColumnsByProps(column, props);
      this.selectedProp = props;
      this.newColumn = column;
      this.showCustomColumnDrawer = false;
    },
    // 过滤未选择的栏目
    filterColumnsByProps(columns, keepProps) {
      const result = [];

      columns.forEach(item => {
        // 深拷贝当前节点，避免修改原数据
        const node = { ...item };
        let shouldKeep = false;

        // 检查当前节点是否在保留列表中
        if (item.prop && keepProps.includes(item.prop)) {
          shouldKeep = true;
        }

        // 如果有子节点，递归处理
        if (item.children && item.children.length > 0) {
          const filteredChildren = this.filterColumnsByProps(item.children, keepProps);
          if (filteredChildren.length > 0) {
            node.children = filteredChildren;
            shouldKeep = true;
          }
        }

        // 如果当前节点或其子节点需要保留，则加入结果
        if (shouldKeep) {
          // 如果当前节点有 children 但被过滤后为空，删除 children 属性
          if (node.children && node.children.length === 0) {
            delete node.children;
          }
          result.push(node);
        }
      });

      return result;
    },
    // 获取所有的 prop
    getAllProps(columns) {
      let props = [];

      columns.forEach(item => {
        // 如果当前节点有 prop，添加到结果中
        if (item.prop) {
          props.push(item.prop);
        }
        // 如果有子节点，递归处理
        if (item.children && item.children.length > 0) {
          props = props.concat(this.getAllProps(item.children));
        }
      });

      return props;
    },
    // 保存自定义栏目
    handleCustomColumn() {
      this.$refs.customColumnRef.saveColumn();
    },
    // 打开自定义栏目弹窗
    openCustomColumn() {
      this.showCustomColumnDrawer = true;
      this.customColumnKey = new Date().getTime();
    },
    formatMoney(value) {
      // 如果值为空或不是数字，返回 '0.00'
      if (value === null || value === undefined || isNaN(value)) {
        return '0.00';
      }
      // toLocaleString 会自动处理千分位，minimumFractionDigits 保证保留两位小数
      return Number(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // 搜索
    clickSearch() {
      this.queryForm.pageNumber = 1;
      this.handleSearch();
    },
    // 整理单号条件
    handleOrderNumber(str) {
      // 1. 按换行符切割成数组（支持 \n, \r\n, \r）
      const lines = str.split(/\r?\n|\r/);

      // 2. 清除每个元素的所有空格，并过滤掉空字符串
      const cleaned = lines
        .map(line => line.replace(/\s/g, '')) // 移除所有空格
        .filter(line => line !== ''); // 删除空元素

      // 3. 去重（保留首次出现的顺序）
      const unique = [...new Set(cleaned)];

      return unique;
    },
    // 获取列表数据
    handleSearch() {
      this.$refs.searchFormRef.validate(async(valid) => {
        if (valid) {
          const dateRange = this.searchForm.dateRange || [];
          const data = {
            pageNumber: this.queryForm.pageNumber,
            pageSize: this.queryForm.pageSize,
            params: {
              customerId: this.searchForm.customerId,
              fundCategory: this.searchForm.fundCategory,
              expenseCategory: this.searchForm.expenseCategory,
              wayBillStatus: this.searchForm.wayBillStatus,
              startTime: dateRange[0] || null,
              endTime: dateRange[1] || null,
              numberField: this.searchForm.numberField,
              numberList: this.handleOrderNumber(this.searchNumber)
            }
          };
          const response = await getFundsTimeSeriesTotal(data.params);
          if (response.code === 200) {
            this.balanceStatistics = response.data;
          }
          const res = await getFundsTimeSeries(data);
          if (res.code === 200) {
            this.queryForm.total = res.data.total;
            this.tableData = res.data.records;
          }
        }
      });
    },
    // 导出
    async handleExport() {
      this.$refs.searchFormRef.validate(async(valid) => {
        if (valid) {
          const dateRange = this.searchForm.dateRange || [];
          const data = {
            customerId: this.searchForm.customerId,
            fundCategory: this.searchForm.fundCategory,
            expenseCategory: this.searchForm.expenseCategory,
            wayBillStatus: this.searchForm.wayBillStatus,
            startTime: dateRange[0] || null,
            endTime: dateRange[1] || null,
            numberField: this.searchForm.numberField,
            numberList: this.handleOrderNumber(this.searchNumber)
          };
          const res = await walletLogExport(data);
          if (res.code === 200) {
            goFinanceExportPage();
          }
        }
      });
    },
    handleReset() {
      this.searchForm.dateRange = [
        dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ];
      this.queryForm.pageNumber = 1;
      this.searchForm.numberField = 'order_number';
      this.searchForm.fundCategory = null;
      this.searchForm.expenseCategory = null;
      this.searchForm.wayBillStatus = null;
      this.searchNumber = '';
      this.searchForm.customerId = null;
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.handleSearch();
    }
  }
};
</script>
<style>
.search-card .el-form-item__label .el-input__inner {
  border: 0 !important;
  outline: none;
  font-weight: bold;
}
</style>
<style scoped>
.finance-container {
  padding: 10px;
  background-color: #f0f2f5;
  height: 100%;
}

/* 1. 顶部卡片样式 */
.stats-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 180px;
  background-color: #fff8ed; /* 米黄色背景 */
  padding: 15px 20px;
  border-radius: 4px;
  position: relative;
  border: 1px solid #fce6d0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.stat-label {
  font-size: 14px;
  color: #000000;
  margin-bottom: 8px;
  font-weight: bold;
}

.stat-value {
  font-size: 18px;
  color: #d32f2f; /* 橙棕色字体 */
  font-weight: bold;
  display: flex;
  align-items: center;
}

.stat-value .svg-icon {
  margin-right: 10px;
  font-size: 20px;
}

.orange-card .stat-label {
  color: rgba(255, 255, 255, 0.9);
}

.orange-card .stat-value {
  color: white;
}

.orange-card .stat-value .svg-icon {
  color: white;
}

/* 2. 搜索区样式 */
.search-card {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
}

/* 3. 表格区样式 */
.table-card {
  border: 1px solid #ebeef5;
}

.table-toolbar {
  margin-bottom: 15px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.fund-category {
  border-radius: 20px;
  padding: 5px 20px;
  color:#fff;
  display: inline-block;
  font-size: 12px;
}
</style>
